module.exports = __webpack_public_path__ + "static/media/snowman.599ba16c.png";